import React from "react";
import { Button, Icon } from "semantic-ui-react";
import {Container} from './style'

const BrowseButton = ({padding, title = 'BROWSE'}) => {
  return (
    <Container padding={padding}>
      <Button className='btn'>
        <Icon name='play circle outline' className='btn-icon' />
        <span>{title}</span>
      </Button>
    </Container>
  );
};

export default BrowseButton;
